import React from "react";
import { PageHero } from "../components/pageHero";
import { Contact as ContactSection } from "../components/contact";

const Contact = ({ data }) => {
  const contact = data.Contact;

  return (
    <>
      <PageHero
        title={contact.heroTitle}
        subtitle={contact.heroSubtitle}
        image="img/hero-contact.jpg"
      />

      <div className="page-section offices">
        <div className="container">
          <div className="card-grid">
            {contact.offices.map((office, i) => (
              <div key={i} className="office-card">
                <i className={office.icon}></i>
                <h3>{office.title}</h3>
                {office.lines.map((line, j) => (
                  <p key={j}>{line}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      <ContactSection data={contact} />
    </>
  );
};

export default Contact;
